
import axios, { AxiosResponse } from 'axios';

import { Response } from '../../../interface/IResponse';

import { ChangePasswordInput, ResponseChangePassword } from '../../../interface/MembersPortal/IChangePassword';



async function changePasswordFunction(input: ChangePasswordInput) : Promise<AxiosResponse<ResponseChangePassword>>{

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Members/Client/memberChangePassword";

        const response: AxiosResponse<ResponseChangePassword> = await axios.post<ResponseChangePassword>(apiUrl, input, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(err){

        throw err;
    }
}





const changePasswordServices = {
    changePassword: changePasswordFunction
};

export default changePasswordServices;